module.exports = __webpack_public_path__ + "static/media/daco_logo.1324ea81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/daco_logo.svg
// module id = 75
// module chunks = 0